import { Avatar } from 'antd';
import styled from 'styled-components';

/**
 * Topbar pill badge — an AntD v6 Avatar with its glyph pinned to true center.
 * The default Avatar centers text via absolute position + JS transform, which
 * drifts once a custom size/border is applied; flex centering is exact.
 */
export const ShiftAvatar = styled(Avatar)`
  &.ant-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: none;
  }

  .ant-avatar-string {
    position: static;
    transform: none !important;
    line-height: 1;
  }
`;

export default ShiftAvatar;
